import UserDetailsModel from "../../models/user/UserDetailsModel";
import configuration from '../../utilities/configuration';
import * as EffectUtility from "../../utilities/EffectUtility";

export async function registerUser(userJson) {
    const endpoint = configuration.apiServer + configuration.apiUsersPath;
    return EffectUtility.postToModel(UserDetailsModel, endpoint, userJson, true, true);
}